import React, { useState } from "react";
import { Check } from "lucide-react";
import AppStoreBadge from "./AppStoreBadge";

const FREE = [
  "Free sessions to start — the full Leo, not a cut-down demo",
  "Maths stories and times tables",
  "Parent dashboard and session notes",
];
const PLUS = [
  "Unlimited chats, every day",
  "Every child on your account included",
  "I remember what they've learned, session to session",
  "Session notes, times-table grid and subject progress",
  "Cancel any time in your iPhone Settings",
];

export default function Pricing() {
  const [annual, setAnnual] = useState(true);
  return (
    <section id="pricing" className="section" data-testid="pricing-section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow rv">Pricing</span>
          <h2 className="h2 rv" style={{ "--d": "80ms" }}>
            Cheaper than <span className="said">one</span> hour of tutoring.
          </h2>
          <p className="lede rv" style={{ "--d": "160ms" }}>
            Start free. If your child likes me (they will), Leo Plus begins with a 7-day free trial.
          </p>
        </div>

        <div className="plans">
          <div className="plan rv">
            <span className="plan-name">Try Leo</span>
            <div className="plan-price">
              <b>£0</b>
            </div>
            <p className="plan-note">No card needed to start.</p>
            <ul>
              {FREE.map((f) => (
                <li key={f}>
                  <Check size={18} strokeWidth={2.5} /> {f}
                </li>
              ))}
            </ul>
            <AppStoreBadge testId="pricing-free" />
          </div>

          <div className="plan plan--plus rv" style={{ "--d": "120ms" }}>
            <span className="plan-ribbon">7 days free</span>
            <span className="plan-name">Leo Plus</span>
            <div className="billing" role="group" aria-label="Billing period">
              <button type="button" aria-pressed={annual} onClick={() => setAnnual(true)}>
                Yearly <em>Save 25%</em>
              </button>
              <button type="button" aria-pressed={!annual} onClick={() => setAnnual(false)}>
                Monthly
              </button>
            </div>
            <div className="plan-price">
              <b>{annual ? "£89" : "£9.99"}</b>
              <span>{annual ? "/ year" : "/ month"}</span>
            </div>
            <p className="plan-note">
              {annual ? "That's about £7.42 a month." : "Billed monthly through the App Store."}
            </p>
            <ul>
              {PLUS.map((f) => (
                <li key={f}>
                  <Check size={18} strokeWidth={2.5} /> {f}
                </li>
              ))}
            </ul>
            <AppStoreBadge light testId="pricing-plus" />
          </div>
        </div>
        <p className="plan-fine">
          UK prices including VAT. Subscriptions are billed through Apple and renew automatically
          unless cancelled at least 24 hours before the end of the period.
        </p>
      </div>
    </section>
  );
}
